<script>
import { defineComponent, ref, reactive, watch } from 'vue'

export default defineComponent({
  name: 'ChoosePeriodModal',
  props: {
    startDate: {
      type: String,
      default: null
    },
    numberOfDays: {
      type: Number,
      default: null
    },
    windowWidth: {
      type: Number,
      default: null
    }
  },
  setup(props, { emit }) {
    const pickerMenu = ref(false)
    const enableDialog = ref(false)
    const observer = ref(null)

    const conditions = reactive({
      baseDate: props.startDate,
      baseNumberOfDays: props.numberOfDays
    })

    const numberOfDayMembers = [
      { value: 1, text: '1' },
      { value: 2, text: '2' },
      { value: 3, text: '3' },
      { value: 4, text: '4' },
      { value: 5, text: '5' },
      { value: 6, text: '6' },
      { value: 7, text: '7' }
    ]

    watch(enableDialog, (val) => {
      if (!val) {
        conditions.baseDate = props.startDate
        conditions.baseNumberOfDays = props.numberOfDays
      }
    })

    /**
     * 閉じるボタン クリックイベント
     */
    const closeButtonClickEvent = () => {
      enableDialog.value = false
    }

    /**
     * 変更ボタン クリックイベント
     * @return {Promise<void>}
     */
    const changeButtonClickEvent = async () => {
      const valid = await observer.value?.validate()
      if (valid) {
        emit('changeCallback', conditions)
        closeButtonClickEvent()
      }
    }

    /**
     * 開始日変更 コールバック
     * @param date
     */
    const dateChangedCallback = (date) => {
      conditions.baseDate = date
    }

    return {
      pickerMenu,
      enableDialog,
      observer,
      conditions,
      numberOfDayMembers,
      closeButtonClickEvent,
      changeButtonClickEvent,
      dateChangedCallback
    }
  }
})
</script>

<template>
  <v-dialog
      v-model="enableDialog"
      width="600"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="windowWidth >= 1280"
          v-bind="attrs"
          v-on="on"
        >
          変更
        </v-btn>
        <v-btn
          v-else
          v-bind="attrs"
          v-on="on"
          color="primary"
          icon
          small
        >
          <v-icon>mdi-calendar-search</v-icon>
        </v-btn>
      </template>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
      >
        <v-card flat>
          <v-toolbar
            color="primary"
            dark
            flat
          >
          <v-toolbar-title>スケジュール表示期間</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-list-item-subtitle>開始日</v-list-item-subtitle>
              </v-col>
              <v-col cols="12" md="8">
                <cs-date-picker
                  :date.sync="conditions.baseDate"
                  @dateChangedCallback="dateChangedCallback"
                >
                  <template v-slot="{ on, attrs }">
                    <validation-provider
                      v-slot="{ errors }"
                      name="開始日"
                      rules="required"
                      class="requiredMark"
                    >
                      <v-text-field
                        v-model="conditions.baseDate"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="errors"
                        append-icon="mdi-calendar"
                        clearable
                        dense
                        readonly
                        hide-details="auto"
                        outlined
                        persistent-hint
                        persistent-placeholder
                      />
                    </validation-provider>
                  </template>
                </cs-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-list-item-subtitle>日数</v-list-item-subtitle>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="conditions.baseNumberOfDays"
                  :items="numberOfDayMembers"
                  dense
                  hide-details="auto"
                  outlined
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="invalid"
            color="primary"
            @click="changeButtonClickEvent"
          >
            変更
          </v-btn>
        </v-card-actions>
      </v-card>
      </validation-observer>
    </v-dialog>
</template>
